import API from "../config/api.js";

export const ActivityService = {
  getActivityList(month, clubId) {
    return API.get(`api/activity/${month}/list/${clubId}`);
  },

  getContributionActivityList(month, clubId) {
    return API.get(`api/activity/${month}/contributions/${clubId}`);
  },

  getCpeActivityList(month, page) {
    return API.get(`api/cpe-activity/${month}/list?page=${page}`);
  },

  getCpeContributionActivityList(month, page) {
    return API.get(`api/cpe-activity/${month}/contributions?page=${page}`);
  },

  submitActivity(url, data) {
    return API.post(`api/${url}`, data);
  },

  getActivityInfo(url, id) {
    return API.get(`api/${url}/${id}`);
  },

  deleteActivity(url, id) {
    return API.delete(`api/${url}/${id}`);
  },

  deleteCommonActivity(id, key) {
    return API.delete(`api/activity/${id}/delete/${key}`);
  },

  submitCommonActivity(data) {
    return API.post(`api/activity/common/create`, data);
  },

  getActivityCommonInfo(key, id) {
    return API.get(`api/activity/${id}/show?key=${key}`);
  },

  calculateActivityPoints(id, key) {
    return API.post(`api/activity/${id}/point-calculation/${key}`);
  },

  getActivityPoints(id, key) {
    return API.get(`api/activity/${id}/points/${key}`);
  },

  ApproveActivity(id, key) {
    return API.post(`api/activity/${id}/approve/${key}`);
  },  

  updatePointStatus(data){
    return API.post(`api/activity/update-points`, data);
  },

  rejectActivity(id, key, data) {
    return API.post(`api/activity/${id}/reject/${key}`, data);
  },  

 downloadAdminReports(type,month, header) { 
    return API.get(`api/activity/${month}/reports/${type}`, header);
  },
 
  getActivityClubReport(clubId, header) { 
    return API.get(`api/activity/${clubId}/club-report`, header);
  },

  updateActivityPoints(data){
    return API.post(`api/activity/point-adjustment`, data);
  },
  getActivityZoneReport(zoneId, header){
    return API.get(`api/activity/${zoneId}/zone-report`, header);
  },

  getActivityContributionClubReport(clubId, header) { 
    return API.get(`api/activity/${clubId}/contribution-club-report`, header);
  },

  getActivityContributionZoneReport(zoneId, header){
    return API.get(`api/activity/${zoneId}/contribution-zone-report`, header);
  }

};



